import * as React from 'react';
import { IIPLWorkflowConnectProps } from './ipl-workflow-container';
import { Workflow } from '../../../components/workflow';
import { IPLDataUploadContainer } from '../ipl-data-upload';
import { IPLConfigContainer } from '../ipl-config';
import { IPLDataSaveContainer } from '../ipl-data-save';
import { DataLoadApi } from '../../../api';
import { DATA_LOAD_STAGE } from '../../../constants';
import * as Actions from '../../../actions';

/**
 * Indicator-Process Links workflow manages transitions between data load flow components
 */
export class IPLWorkflow extends React.Component<IIPLWorkflowConnectProps> {
  public componentWillMount(): void {
    this.props.dispatch(Actions.UI.setDataLoadStage(DATA_LOAD_STAGE.DATA_UPLOAD_INITIAL));
  }

  public componentWillUnmount(): void {
    DataLoadApi.cancelDataLoad().request()
      .then((): void => {
        this.props.dispatch(Actions.Batch.clearAppState());
      })
      .catch((): void => {
        this.props.dispatch(Actions.Batch.clearAppState());
      });
  }

  public render(): JSX.Element {
    return (
      <Workflow
        stage={this.props.ui.stage}
        upload={<IPLDataUploadContainer />}
        config={<IPLConfigContainer />}
        result={<IPLDataSaveContainer />}
      />
    );
  }
}
